export const IVA_RATES = [21, 10.5, 0];

export function getDefaultRate() {
  return 21;
}
